import { FormError, useFormContext, useStoreState } from '@ariakit/react'
import { ComponentProps } from 'react'

export const useIsValidFormField = (props: Pick<ComponentProps<typeof FormError>, 'name'>) => {
  const formStore = useFormContext()
  const error = useStoreState(formStore, () => {
    return (
      formStore != null && formStore.getFieldTouched(props.name) && formStore.getError(props.name)
    )
  })
  return !error
}
